import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

function TradeRoutePage() {
  return <Outlet />;
}

export const Route = createFileRoute('/trade')({
  loader: ({ location }) => {
    if (location.pathname !== '/trade') {
      return null;
    }

    throw redirect({
      params: {
        asset: 'BTC',
      },
      replace: true,
      to: '/trade/$asset',
    });
  },
  component: TradeRoutePage,
});
